import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, MenuItem } from '@material-ui/core';
import { DateTime, Dropdown, TextInput } from '../../../FlowConfigurationInputs';
import { options, label } from './config';

function Schedule ({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const [scheduleType, setScheduleType] = useState('');

    useEffect(() => {
        if (!action.fields.scheduleType) { action.fields.scheduleType = { value: '' }; }
        else { setScheduleType(action.fields.scheduleType.value); }
    }, [action]);

    const handleSelect = (event) => {
        setScheduleType(event.target.value);
        action.fields = { scheduleType: { value: event.target.value } };
    };

    return (
        <div>
            <div className="form-element">
                {t(label + 'TIMING-TYPE')}
                <Select value={scheduleType} onChange={handleSelect} variant="outlined" fullWidth>
                    <MenuItem value="once">{t(label + 'ONLY-ONCE')}</MenuItem>
                    <MenuItem value="minute">{t(label + 'MINUTE')}</MenuItem>
                    <MenuItem value="daily">{t(label + 'DAILY')}</MenuItem>
                    <MenuItem value="weekly">{t(label + 'WEEKLY')}</MenuItem>
                    <MenuItem value="monthly">{t(label + 'MONTHLY')}</MenuItem>
                </Select>
            </div>
            {scheduleType === 'once' &&
                <div className="form-element">
                    {t(label + 'DATE-TIME')}
                    <DateTime action={action} inputName="specifiedDate" type="datetime-local" />
                </div>
            }
            {scheduleType === 'minute' &&
                <div>
                    <div className="form-element">
                        {t(label + 'START-DATE-TIME')}
                        <DateTime action={action} inputName="specifiedDate" type="datetime-local" />
                    </div>
                    <div className="form-element">
                        {t(label + 'MINUTE')}
                        <TextInput action={action} inputName="specifiedTime" options={options.textInput} />
                    </div>
                    <div className="form-element">
                        {t(label + 'END-DATE')}
                        <DateTime action={action} inputName="endDate" type="datetime-local" />
                    </div>
                </div>
            }
            {scheduleType === 'daily' &&
                <div>
                    <div className="form-element">
                        {t(label + 'START-DATE-TIME')}
                        <DateTime action={action} inputName="specifiedDate" type="datetime-local" />
                    </div>
                    <div className="form-element">
                        {t(label + 'END-DATE')}
                        <DateTime action={action} inputName="endDate" />
                    </div>
                </div>
            }
            {scheduleType === 'weekly' &&
                <div>
                    <div className="form-element">
                        {t(label + 'DAY')}
                        <Dropdown action={action} inputName="specifiedDate" options={options.dropdownDay} multiple />
                    </div>
                    <div className="form-element">
                        {t(label + 'TIME')}
                        <DateTime action={action} inputName="specifiedTime" type="time" />
                    </div>
                    <div className="form-element">
                        {t(label + 'END-DATE')}
                        <DateTime action={action} inputName="endDate" />
                    </div>
                </div>
            }
            {scheduleType === 'monthly' &&
                <div>
                    <div className="form-element">
                        {t(label + 'MONTH')}
                        <Dropdown action={action} inputName="specifiedDate" options={options.dropdownMonth} multiple />
                    </div>
                    <div className="form-element">
                        {t(label + 'DAY')}
                        <Dropdown action={action} inputName="specifiedDay" options={options.dropdownDays} multiple />
                    </div>
                    <div className="form-element">
                        {t(label + 'TIME')}
                        <DateTime action={action} inputName="specifiedTime" type="time" />
                    </div>
                    <div className="form-element">
                        {t(label + 'END-DATE')}
                        <DateTime action={action} inputName="endDate" />
                    </div>
                </div>
            }
        </div>
    );
}
export default Schedule;